import { useEffect } from 'react'
import {
  Button,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  Paper,
} from '@material-ui/core'
import Alert from '@mui/material/Alert'

import logo from '../../../assets/images/logo_text_3.png'
import illustration from '../../../assets/images/illustration1.svg'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import styles from '../styles'
import AuthServiceExtranet from '../api'
const schema = yup.object().shape({
  email: yup.string().required("Le nom d'utilisateur est requis"),
  password: yup.string().required('Le mot de passe est requis'),
})

export default function LoginExtranetForm({ onError, onSuccess, error }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  })
  const onSubmit = async (data) => {
    try {
      const response = await AuthServiceExtranet.login(
        data.email,
        data.password
      )
      onSuccess(response)
    } catch (error) {
      onError('Mot de passe ou identifiant incorrecte')
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
        <Paper style={styles.paper}>
          <img src={logo} alt="Logo" style={styles.logo} />
          <Typography component="h1" variant="h5" style={styles.title}>
            Se connecter
          </Typography>
          <img
            src={illustration}
            alt="Illustration"
            style={styles.illustration}
          />
          <Alert severity="info">
            Notre interface a changé mais vos identifiants pour vous connecter à
            votre extranet sont toujours les mêmes.
          </Alert>
          <form
            style={styles.form}
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            id="login-form"
          >
            {error && (
              <Paper style={styles.errorBox}>
                <Typography variant="body2" style={styles.error}>
                  {error}
                </Typography>
              </Paper>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="uname"
                  name="email"
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  label="Nom d'utilisateur"
                  autoFocus
                  {...register('email')}
                  error={!!errors.email}
                  helperText={errors?.email?.message}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  label="Mot de passe"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  {...register('password')}
                  error={!!errors.password}
                  helperText={errors?.password?.message}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              style={styles.submit}
            >
              Se connecter
            </Button>
            <Grid
              container
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Grid item>
                <Link
                  href="https://connect.datacopro.org/code/"
                  variant="body2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Code de connexion
                </Link>
              </Grid>
              <Grid item>
                <Link
                  href="https://connect.datacopro.org/demande-de-reinitialisation-du-mot-de-passe"
                  variant="body2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mot de passe oublié?
                </Link>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </Container>
  )
}
